import React, {Component} from "react";
import Section from "./layouts/Section";
import {Link} from "react-router-dom";
import SEO from "./SEO";

class PCLaptopRepair extends Component {
    render() {
        return (
            <>
                <SEO 
                    title="PC Laptop Repair | iScreenFix"
                    description="Does Your Computer Need Repair? Bring your PC in for Data Recovery, Hardware Repair or even ask us to Build Your PC!"
                    keywords="PC repair, laptop repair, computer repair, hardware repair, data recovery, virus removal, PC building, Myrtle Beach"
                    canonical="https://www.iscreenfix.com/pc-laptop-repair"
                />
                <Section title={'PC/Laptop Repairs'}>
                    <section className="section page-content">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <img className="img-fluid shadow" style={{borderRadius: '10px'}} src={process.env.PUBLIC_URL + '/assets/images/macbanner.jpg'} alt="Laptop Repair Services" />
                                        </div>
                                        <div className="col-md-6 mt-4 mt-md-0">
                                            <h2 className="h1 text-dark mb-25">Desktop or Laptop, Windows or Mac, We've Got Your Back.</h2>
                                            <p>At iScreenFix, we understand how important your computer is for your 
                                                daily life and work. That's why our team of skilled technicians is dedicated 
                                                to providing you with top-quality PC computer repair services. Our extensive 
                                                range of solutions ensures that we can quickly diagnose and resolve any issues 
                                                you may encounter. With our reliable and efficient services, you can get back 
                                                to what matters most.</p>
                                            <ul className="check-list mt-30">
                                                <li>Hardware repair and upgrades.</li>
                                                <li>Virus and malware removal.</li>
                                                <li>Data transfer and data backup.</li>
                                                <li>Network troubleshooting</li>
                                                <li>Custom PC and Server builds.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    
                                    <div className="row mt-70">
                                        <div className="col-md-6">
                                            <h3 className="text-dark mb-25">Repair Details</h3>
                                            <p>For those who want to power up their experience,
                                                we also offer remote management services. If you're interested in 
                                                learning more about our remote management services, check out the link below.
                                            </p>
                                          <Link to={'/monitoring'} className="btn btn-primary mt-20 mr-3 mr-md-4 initiate-scripts">Remote Management Services</Link>
                                        
                                        </div>
                                        <div className="col-md-6 mt-4 mt-md-0">
                                            <img className="img-fluid shadow" style={{borderRadius: '10px'}} src={process.env.PUBLIC_URL + '/assets/images/anythingit-rmm.jpg'} alt="Remote Management Services" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 mt-5 mt-lg-0">
                                    <div className="widget widget-category">
                                        <div className="widget-heading">Category</div>
                                        <ul className="category-list list-unstyled p-4">
                                        <li><span className="fas fa-caret-right mr-2" /><Link to={'/pc-laptop-repair'} className="text-reset initiate-scripts">PC/Laptop Repair</Link></li>
                                            <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/mobile-repair'} className="text-reset initiate-scripts">Mobile Device Repair</Link></li>
                                            <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/game-repair'} className="text-reset initiate-scripts">Game Console Repair</Link></li>
                                            <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/monitoring'} className="text-reset initiate-scripts">Monitoring Solutions</Link></li>
                                            <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/consulting'} className="text-reset initiate-scripts">Consultations</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Section>
            </>
        );
    }
}

export default PCLaptopRepair;